import { createSlice } from "@reduxjs/toolkit";

export const holidayCounterReducer = createSlice({
  name: "holidayCounter",
  initialState: {
    entitled: 28,
    taken: 0,
    pending: 0,
  },
  reducers: {
    incrementPending: (state) => {
      state.pending += 1;
    },
    decrementPending: (state) => {
      state.pending -= 1;
    },
    incrementTaken: (state) => {
      state.taken += 1;
    },
    decrementTaken: (state) => {
      state.taken -= 1;
    },
  },
});

export const {
  incrementPending,
  incrementTaken,
  decrementPending,
  decrementTaken,
} = holidayCounterReducer.actions;
export const selectHolidayCounter = (state) => state.holidayCounter;
export default holidayCounterReducer.reducer;
